import React from "react";

import { withTranslation } from "react-i18next";
import DeviceStatus from "../../../../../helpers/DeviceStatus";
import {faCircleNotch} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const DeviceStatusCell = props => (
  <b>
      {DeviceStatus.inTransition(props.device.status) ?
          <FontAwesomeIcon className="mr-2" icon={faCircleNotch} spin /> : ""}
      {props.t(DeviceStatus.getTranslationByStatus(props.device.status))}
  </b>
);

export default withTranslation()(DeviceStatusCell);
